import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { CalcScreen, ListRow } from '../../components/shell';
import { C, FONT, SP } from '../../theme/tokens';

type Calc = { title: string; description: string; screen: string };

const CALCS: Calc[] = [
  {
    title: 'Air Changes Per Hour',
    description: 'ACH from supply CFM and cleanroom volume',
    screen: 'CleanroomAirChangesPerHour',
  },
  {
    title: 'ISO 14644-1 Particle Count',
    description: 'Required sample locations and sample volume per ISO class',
    screen: 'CleanroomParticleCountCalculator',
  },
  {
    title: 'Particle Concentration',
    description: 'Particles per cubic foot from raw count and sample volume',
    screen: 'CleanroomParticleConcentration',
  },
  {
    title: 'HEPA Scan Rate',
    description: 'Probe traverse speed for filter leak scanning',
    screen: 'CleanroomScanRate',
  },
  {
    title: 'Upstream Challenge',
    description: 'Upstream aerosol concentration needed for HEPA leak test',
    screen: 'CleanroomUpstreamChallenge',
  },
];

export default function CleanroomCalculationsScreen() {
  const nav = useNavigation();
  return (
    <CalcScreen title="Cleanroom Calculations" subtitle="Air changes, particle counting, HEPA scan rate">
      <Text style={styles.sectionLabel}>Calculations</Text>
      {CALCS.map((c, i) => (
        <ListRow
          key={c.screen}
          index={i}
          label={c.title}
          description={c.description}
          onPress={() => nav.navigate(c.screen as never)}
        />
      ))}
    </CalcScreen>
  );
}

const styles = StyleSheet.create({
  sectionLabel: {
    fontFamily: FONT.sans,
    fontSize: 12,
    color: C.dim,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: SP.sm,
  },
});
